var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPiresLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M1867-583a32,32,0,0,0-32,32,32,32,0,0,0,32,32,32,32,0,0,0,32-32A32,32,0,0,0,1867-583Zm-7.946,37v6.59c0,5.288-5.985,4.283-5.747,4.061,1.073-1,1.149-4.575,1.149-5.747V-555.27a2.3,2.3,0,0,1,2.3-2.3h12.58a2.3,2.3,0,0,1,2.3,2.3,2.3,2.3,0,0,1-2.3,2.3h-10.281Zm19.044-1.468a10.486,10.486,0,0,1-8.3,3.69h-3.847a2.3,2.3,0,0,1-2.3-2.3,2.3,2.3,0,0,1,2.3-2.3h3.847a5.949,5.949,0,0,0,4.785-2.057,7.584,7.584,0,0,0,1.639-4.84,7.584,7.584,0,0,0-1.639-4.84,5.949,5.949,0,0,0-4.785-2.057h-13.042a2.3,2.3,0,0,1-2.3-2.3,2.3,2.3,0,0,1,2.3-2.3H1869.8c7.236,0,11.022,5.782,11.022,11.494A12.074,12.074,0,0,1,1878.1-547.466Z",
    transform: "translate(-1835 583)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiresLogo);
export default __webpack_public_path__ + "static/media/pires-logo.1ae8944c202e524b10dba6ce1eeb7996.svg";
export { ForwardRef as ReactComponent };